module.exports = __webpack_public_path__ + "img/stayconnected-locked.686191ef.svg";